import { IGroup } from '@fluentui/react';
import { GroupByOption } from '../../../types';
import { groupBy, map } from 'lodash';

/**
 * This takes group data and item list, and determines the start index
 * & length for each group.
 */
export const matchItemListToGroupList = <T,>(
  itemList: T[],
  groupData: IGroup[],
  groupByOption: GroupByOption
) => {
  const groupedItemList = groupBy(itemList, item => {
    if (typeof groupByOption?.onGroupBy === 'function') {
      return groupByOption?.onGroupBy(item);
    }

    return item?.[groupByOption?.key];
  });
  // This requires let to keep tabs on the final item.
  // We should eventually find a static way to do this
  let last = 0;

  // Todo, figure out how to merge in any headers missing a data group
  return map(groupData, group => {
    const itemsInGroup = groupedItemList[group.key] || [];

    const newGroup: IGroup = {
      ...group,
      startIndex: last,
      count: itemsInGroup.length,
    };

    last += itemsInGroup.length;

    return newGroup;
  });
};
